export function getNativeVersion() {
  const userAgent = navigator.userAgent;
  const match = /\bshopee-food-driver\/([0-9.]+)\b/.exec(userAgent);
  return (match && match[1]) || '';
}

function extractVersionInfo(version: string) {
  const match = /\b([0-9]+)[.]([0-9]+)[.]([0-9]+)\b/.exec(version);
  if (!match) {
    return null;
  }
  return {
    major: parseInt(match[1], 10),
    minor: parseInt(match[2], 10),
    patch: parseInt(match[3], 10),
  };
}

/**
 * Returns true if current native app version is newer than provided version
 */
export function isVersionReleased(version: string) {
  const currentVersion = getNativeVersion();
  const currentVersionInfo = extractVersionInfo(currentVersion);
  const versionInfo = extractVersionInfo(version);

  // on invalid version or invalid provided version, assume older version.
  if (!versionInfo || !currentVersionInfo) {
    return false;
  }

  if (currentVersionInfo.major !== versionInfo.major) {
    return currentVersionInfo.major >= versionInfo.major;
  }

  if (currentVersionInfo.minor !== versionInfo.minor) {
    return currentVersionInfo.minor >= versionInfo.minor;
  }

  return currentVersionInfo.patch >= versionInfo.patch;
}
